import clsx from 'clsx'

import { useModal } from '@/components/Modal'
import { Modal } from '@/ui/Modal'
import styles from './EndOfShiftModal.module.scss'
import { Button } from '@/ui/Button'
import { Routes } from '@/modules/Workstation/ui/components/Routes'
import { useGetUnfinishedLogs } from '@/modules/CombinedLogs/api/useGetUnfinishedLogs'
import { UnfinishedLogs } from '../../UnfinishedLogs'
import { Loader } from '@/ui/Loader'

export const EndOfShiftModal = () => {
    const { closeModal } = useModal()
    const { data: unfinishedLogs, isLoading } = useGetUnfinishedLogs()

    return (
        <Modal onClose={closeModal} className={clsx(styles.modal)} hideCloseButton>
            {isLoading ? (
                <div className={styles.loaderContainer}>
                    <Loader />
                </div>
            ) : (
                <>
                    <div className={styles.container}>
                        <h1 className={styles.title}>End of shift {unfinishedLogs?.dutyCode}</h1>

                        <div className={styles.titleContainer}>
                            <h3 className={styles.subtitle}>Shift averages</h3>

                            <Routes isEditable={false} />
                        </div>

                        <div className={styles.recordsContainer}>
                            <h3 className={styles.subtitle}>
                                {unfinishedLogs?.unfinishedLogs.length} unfinished records
                            </h3>

                            {unfinishedLogs?.unfinishedLogs.length ? (
                                <div className={styles.logsContainer}>
                                    <UnfinishedLogs actionCallback={closeModal} />
                                </div>
                            ) : (
                                <span className={styles.greatWork}>Great work!</span>
                            )}
                        </div>
                    </div>

                    <div className={clsx(styles.footer)}>
                        <Button
                            variant="tertiary"
                            rounded
                            onClick={closeModal}
                            type="button"
                            className={styles.closeButton}
                        >
                            Close
                        </Button>
                    </div>
                </>
            )}
        </Modal>
    )
}
